import { Table } from '@tanstack/react-table'

import { Log, FilterType, DailyLogCode, MileageLossCode, RouteSelectionMode } from '@/types/logs'
import { compareValueWithPrefix, extractParts } from '@/helpers/compareValueWithPrefix'

const dailyLogCodes: string[] = Object.values(DailyLogCode)

const sortRoutes = (routes: string[]): string[] => {
    return routes.sort((routeA, routeB) => {
        const [prefixA, numA, suffixA] = extractParts(routeA)
        const [prefixB, numB, suffixB] = extractParts(routeB)

        return compareValueWithPrefix([prefixA, numA, suffixA], [prefixB, numB, suffixB])
    })
}

export const formatRouteFilterValues = (
    values: string[],
    table: Table<Log>,
    filter: FilterType = FilterType.All
): string[] => {
    const availableRoutes: string[] = table.getCoreRowModel().rows.reduce<string[]>((acc, row) => {
        const origRoutes = row.original.routes || []

        if (row.original.routeSelectionMode === RouteSelectionMode.None) {
            return acc
        }

        if (filter === FilterType.DailyLog && dailyLogCodes.includes(row.original.code)) {
            acc.push(...origRoutes)
        }

        if (filter === FilterType.MileageLoss && row.original.code in MileageLossCode) {
            acc.push(...origRoutes)
        }

        if (filter === FilterType.All) {
            acc.push(...origRoutes)
        }

        return acc
    }, [])

    const filteredValues = values.filter((route) => availableRoutes.includes(route))

    return sortRoutes(filteredValues)
}
